import { render, staticRenderFns } from "./cn2061.vue?vue&type=template&id=67efbc46&scoped=true&"
import script from "./cn2061.vue?vue&type=script&lang=js&"
export * from "./cn2061.vue?vue&type=script&lang=js&"
import style0 from "./cn2061.vue?vue&type=style&index=0&id=67efbc46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67efbc46",
  null
  
)

export default component.exports